// Import Bootstrap's CSS
import 'bootstrap/dist/css/bootstrap.min.css';
// Import Bootstrap's JS (only if you need it)
import 'bootstrap/dist/js/bootstrap.bundle.min';

export default defineNuxtPlugin((nuxtApp) => {
  // You can add any custom Bootstrap configurations here if needed
});
